import React from 'react';
import classnames from 'classnames';
import { classes } from './SkeletonLine.st.css';
/** SkeletonLine */
export const SkeletonLine = (props) => (React.createElement("div", { "data-hook": props['data-hook'], className: classnames(classes.skeletonLine, props.className) }));
//# sourceMappingURL=SkeletonLine.js.map